import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import type { OnboardingNudge } from 'fym-shared/src/music24/onboardingChecklist';
import { useArtistSwitcher } from '../../accountSelector/useArtistSwitcher';
import { catalogAddSongPath } from '../../smartLinks/catalog/addSong/catalogAddSongPath';

/**
 * Runs the nudge of a checklist item (owner answer 4, 2026-10-09). `cover` opens the cover step of
 * the "Add a song" page for the first-release song, under the artist of the song. While the demo
 * artist is active, the hook first selects the artist of the song.
 */
export function useChecklistNudge(): (nudge: OnboardingNudge) => void {
  const navigate = useNavigate();
  const { active, onSelect } = useArtistSwitcher();
  const isDemoActive = active?.isDemo === true;

  return useCallback(
    (nudge: OnboardingNudge) => {
      if (isDemoActive) {
        onSelect(nudge.accountId);
      }
      // eslint-disable-next-line no-void
      void navigate(
        catalogAddSongPath({ item: nudge.catalogItemUuid, step: 'cover', from: 'home', accountId: nudge.accountId })
      );
    },
    [isDemoActive, navigate, onSelect]
  );
}
